import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LogInButton from 'flarum/forum/components/LogInButton';
import LogInButtons from 'flarum/forum/components/LogInButtons';
import { handleOAuthCallback } from '../../../../devconnect-oauth-core/js/src/forum/service/OAuthCallbackHandler';
import SocialAccountItem from '../../../../devconnect-oauth-core/js/src/forum/components/SocialAccountItem';
const settingsPageComponent = 'flarum/forum/components/SettingsPage';
app.initializers.add('devconnect-oauth-yandex', () => {
  extend(LogInButtons.prototype, 'items', items => {
    // Полностью настроенный сервер — обязательное условие отображения кнопки Яндекс ID.
    if (app.forum.attribute('devconnectOauthYandexEnabled')) {
      items.add('devconnect-yandex', m(LogInButton, {
        className: "Button LogInButton--yandex",
        icon: "fab fa-yandex",
        path: `/auth/yandex?return=${encodeURIComponent(window.location.href)}`
      }, app.translator.trans('devconnect-oauth-yandex.forum.log_in')), 80);
    }
  });
  extend(settingsPageComponent, 'accountItems', items => {
    items.add('devconnect-yandex-account', m(SocialAccountItem, {
      provider: "yandex",
      icon: "fab fa-yandex",
      configuredAttribute: "devconnectOauthYandexEnabled",
      linkingAttribute: "devconnectOauthYandexLinkingEnabled",
      linkedAttribute: "devconnectOauthYandexLinked",
      title: app.translator.trans('devconnect-oauth-yandex.forum.account_title'),
      linkedText: app.translator.trans('devconnect-oauth-yandex.forum.account_linked'),
      notLinkedText: app.translator.trans('devconnect-oauth-yandex.forum.account_not_linked'),
      connectText: app.translator.trans('devconnect-oauth-yandex.forum.connect'),
      disconnectText: app.translator.trans('devconnect-oauth-yandex.forum.disconnect'),
      disconnectConfirmText: app.translator.trans('devconnect-oauth-yandex.forum.disconnect_confirm'),
      disconnectedText: app.translator.trans('devconnect-oauth-yandex.forum.disconnected'),
      disconnectErrorText: app.translator.trans('devconnect-oauth-yandex.forum.disconnect_error')
    }), 60);
  });

  // Flarum создаёт модель форума после initializers, поэтому callback запускается на штатной стадии beforeMount.
  app.beforeMount(() => handleOAuthCallback(app, app.translator.trans('devconnect-oauth-yandex.forum.session_expired'), app.translator.trans('devconnect-oauth-yandex.forum.linked_success')));
});